import type { QueryFunctionContext } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { suggestionActionsQueryKeys } from "app/pages/sales-intelligence/modules/suggestions/query/key-factory/factory";
import type { SuggestedActions } from "app/pages/sales-intelligence/modules/suggestions/types";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export default function useSuggestedActionQuery() {
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: suggestionActionsQueryKeys.list(),
        queryFn({ signal }: QueryFunctionContext): Promise<SuggestedActions> {
            return salesApiService.suggestions.fetchSuggestionActions({
                cancellation: signal,
            });
        },
    });
}
